<div
    class="flex relative mr-md justify-center content-center"
    [ngClass]="{
        'mt-sm': isVertical && !isFirst,
        'mt-xs': !isVertical || (isVertical && isFirst),
        'mb-xs': isLast
    }">
    <div class="min-h-radio min-w-radio w-radio h-radio relative mr-xs">
        <input
            type="radio"
            class="absolute w-full h-full peer left-0 mb-0 mr-0 mt-0 ml-0 opacity-0 z-30"
            [ngClass]="{
                'cursor-pointer': !disabled
            }"
            [id]="inputId"
            [value]="value"
            [checked]="checked"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabel ? ariaLabel : null"
            [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy : labelId"
            [attr.aria-checked]="checked"
            (change)="changed.emit({ value })" />
        <div
            [ngClass]="{
                'border-radio-error': invalid,
                'border-2': invalid,
                'border-radio-outline': !invalid
            }"
            class="absolute z-20 left-0 right-0 top-0 bottom-0 border border-solid rounded-radio before:transition-all before:scale-0 before:content-[''] hover:after:scale-[2.0] peer-hover:after:scale-[2.0] peer-disabled:opacity-50 peer-focus:outline peer-focus:outline-2 peer-focus:outline-radio-focus peer-checked:border-radio-outline-selected peer-checked:before:bg-radio-outline-selected peer-checked:before:block peer-checked:before:w-full peer-checked:before:h-full peer-checked:before:rounded-radio peer-checked:before:scale-50"></div>
        <div
            [ngClass]="{
                'peer-hover:scale-[1.8]': !disabled
            }"
            class="z-10 content-[''] absolute w-full h-full top-0 opacity-0 bg-radio-shadow rounded-radio scale-[0] peer-focus:scale-[1.8] peer-hover:opacity-100 transition-all"></div>
    </div>

    <label class="flex items-center" [for]="inputId" [id]="labelId" [ngClass]="{ 'opacity-50': disabled }">
        <ng-content></ng-content>
    </label>
</div>
